import {
  Directive,
  OnChanges,
  OnDestroy,
  Input,
  ElementRef,
  SimpleChanges,
  HostListener,
} from '@angular/core';
import { ScrollProgressService } from '../../services/scroll-progress/scroll-progress.service';

@Directive({
    selector: '[scrollProgress]',
    standalone: false
})
export class ScrollDirective implements OnChanges, OnDestroy {
  @Input() public scrollProgress: any;

  isEnabled = false;
  firstTime: boolean = true;

  interval: any;

  currentElement = { start: 0, end: 0 };
  currentPerc: number = 0;

  constructor(
    private el: ElementRef,
    private scrollService: ScrollProgressService
  ) {
    this.isEnabled = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['scrollProgress'] && changes['scrollProgress'].firstChange) {
      this.isEnabled = true;
      this.configure();
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    const target: HTMLElement = event.target;
    if (this.firstTime) {
      this.configure();
      this.firstTime = false;
    }

    const perc = this.getCurrentPerc(target);
    // this.progressService.setProgressScroll(perc);
    // if (this.interval) {
    //   clearTimeout(this.interval);
    // }
    // this.interval = setTimeout(() => {
    // }, 800);
    this.hasScrolled(perc);
  }

  configure() {
    this.el.nativeElement.scrollTop = 0;
    this.hasScrolled(0, true);
  }

  getCurrentPerc(el: HTMLElement) {
    const end = el.scrollHeight;
    const pageVisible = el.clientHeight;
    const scroll = el.scrollTop + pageVisible;

    return Math.round(Math.min(1, scroll / end) * 10000) / 10000;
  }

  hasScrolled(perc: number, isFirst = false) {
    if (isFirst) {
      this.setScroll(0);
    } else {
      if (this.isEnabled) {
        this.setScroll(perc);
      }
    }
  }

  setScroll(perc: any) {
    this.scrollService.setScroll(perc);
  }

  ngOnDestroy() {
    this.isEnabled = false;
  }
}
